import React, { ReactNode } from 'react';

import { SidebarProps } from 'carbon-react/lib/components/sidebar';
import Typography from 'carbon-react/lib/components/typography';
import { Sidebar } from '@futrli/ui-components';

interface ReportingSidebarProps {
  ['aria-label']?: string;
  children?: ReactNode;
  className?: string;
  onCancel?: () => void;
  open?: boolean;
  sidebarProps?: Omit<SidebarProps, 'children' | 'onCancel' | 'open' | 'header'>;
  title?: string;
}

export const ReportingSidebar = ({
  ['aria-label']: ariaLabel,
  children,
  className,
  onCancel,
  open,
  sidebarProps = {},
  title
}: ReportingSidebarProps) => (
  <Sidebar
    aria-label={ariaLabel}
    className={className}
    header={
      title ? (
        <Typography variant="h2" fontWeight="700">
          {title}
        </Typography>
      ) : undefined
    }
    onCancel={onCancel}
    open={!!open}
    {...sidebarProps}
  >
    {children}
  </Sidebar>
);
